import React from 'react';
import ResultDisplay from 'components/resultDisplay/ResultDisplay';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  buildLandingPath,
  buildOrderHistoryListPath,
  buildOrderHistoryDetailPath,
} from 'utils/pathBuilder';
import './NewOrderResult.scss';
import successIcon from 'assets/images/success.png';
import NeedHelp from 'components/needHelp/NeedHelp';

interface NewOrderResultLocationState {
  reservationNo?: string;
  orderID?:number;
}

const NewOrderResult: React.FC = () => {
  const { t } = useTranslation('new_order_result');
  const navigate = useNavigate();
  const location = useLocation();

  // Get order info from location state
  const state = location.state as NewOrderResultLocationState | null;

  const reservationNo = state?.reservationNo;
  const displayReservationNo = reservationNo || '-';
  const orderID = state?.orderID;


  const handleGoHome = () => {
    navigate(buildLandingPath());
  };

  const handleViewOrder = () => {
    if (reservationNo) {
      navigate(buildOrderHistoryDetailPath(String(orderID)));
    } else {
      navigate(buildOrderHistoryListPath());
    }
  };

  // Note: WhatsApp link handled by default link behaviour (help phone text)

  return (
    <>
      {reservationNo && (
        <ResultDisplay
          title={t('thankYou')}
          imageUrl={successIcon}
          onCancel={handleGoHome}
          onNext={handleViewOrder}
          cancelText={t('goToHomePage')}
          nextText={t('viewOrder')}
        >
          {/* Order Confirmation Text */}
          <div className="new-order-result-message">
            <div className="new-order-result-confirmation">
              {t('orderReserved', { reservationNo: displayReservationNo })}
            </div>
            <div className="new-order-result-notification">
              {t('finalCollectionTime')}
            </div>
          </div>

          {/* Help/Support Line */}
          <div className="new-order-result-help">
            <NeedHelp />
          </div>
        </ResultDisplay>
      )}
    </>
  );
};

export default NewOrderResult;
